<template>
  <div class="text-center" >
    <v-card>
      <!-- <v-alert type="success">Upozornění odesláno.</v-alert> -->
      <v-container>
        <v-row justify="center">
          <v-col cols="9">
            <h1 class="text-center" id="root">{{title}}</h1>
            <v-form
              ref="form"
              v-model="formValid"
            >
              <v-container>
                <v-row>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.firstName"
                      :rules="[rules.required]"
                      label="Jméno"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.lastName"
                      :rules="[rules.required]"
                      label="Příjmení"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.email"
                      :rules="[rules.required, rules.email]"
                      label="E-mail"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.phone1"
                      :rules="[rules.required, rules.phone]"
                      label="Telefon"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.phone2"
                      :rules="[rules.phone]"
                      label="Telefon 2"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.phone3"
                      :rules="[rules.phone]"
                      label="Telefon 3"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.password"
                      :rules="form.id ? [rules.minLength(6)] : [rules.required, rules.minLength(6)]"
                      label="Heslo"
                      :type="show1 ? 'text' : 'password'"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show1 = !show1"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="green"
                      v-model="form.passwordConfirmation"
                      :rules="form.id ? [formRules.passwordConfirmation] : [rules.required, formRules.passwordConfirmation]"
                      :type="show2 ? 'text' : 'password'"
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show2 = !show2"
                      label="Heslo znovu"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      color="green"
                      v-model="form.street"
                      :rules="[rules.required]"
                      label="Ulice"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      color="green"
                      v-model="form.streetNumber"
                      :rules="[rules.required]"
                      label="Č. p."
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      color="green"
                      v-model="form.city"
                      :rules="[rules.required]"
                      label="Město"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      color="green"
                      v-model="form.zip"
                      :rules="[rules.required]"
                      label="PSČ"
                      required
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-select
                      color="green"
                      v-model="form.cityDistrictId"
                      label="Městská část"
                      :items="districts"
                      item-value="id"
                      item-text="name"
                      :rules="[rules.required]"
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      color="green"
                      v-model="form.description"
                      label="Popis"
                      rows="3"
                      outlined
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-select
                      color="green"
                      label="Vyberte typ stravy"
                      v-model="form.foodTypes"
                      :items="foodTypes"
                      :search-input.sync="search"
                      item-text="name"
                      return-object
                      hide-selected
                      multiple
                      persistent-hint
                      small-chips
                      deletable-chips
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>

                <v-checkbox
                  color="green"
                  v-model="form.delivery"
                  label="Jiná dodací adresa"
                ></v-checkbox>

                <div v-if="form.delivery">
                  <v-row>
                    <v-col cols="8">
                      <v-text-field
                        color="green"
                        v-model="form.deliveryStreet"
                        :rules="form.delivery ? [rules.required] : []"
                        label="Ulice"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        color="green"
                        v-model="form.deliveryStreetNumber"
                        :rules="form.delivery ? [rules.required] : []"
                        label="Č. p."
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="8">
                      <v-text-field
                        color="green"
                        v-model="form.deliveryCity"
                        :rules="form.delivery ? [rules.required] : []"
                        label="Město"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        color="green"
                        v-model="form.deliveryZip"
                        :rules="form.delivery ? [rules.required] : []"
                        label="PSČ"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-select
                        color="green"
                        v-model="form.deliveryCityDistrictId"
                        label="Městská část"
                        :items="districts"
                        item-text="name"
                        item-value="id"
                        :rules="form.delivery ? [rules.required] : []"
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </div>

                <v-checkbox
                  color="green"
                  v-model="form.company"
                  label="Jsem firma"
                ></v-checkbox>

                <div v-if="form.company">
                  <v-row>
                    <v-col>
                      <v-text-field
                        color="green"
                        v-model="form.companyName"
                        :rules="form.company ? [rules.required] : []"
                        label="Název"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        color="green"
                        v-model="form.ico"
                        :rules="form.company ? [rules.required] : []"
                        label="IČO"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col>
                      <v-text-field
                        color="green"
                        v-model="form.dic"
                        :rules="form.company ? [rules.required] : []"
                        label="DIČ"
                        outlined
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <v-row>
                  <v-col>
                    <v-select
                      color="green"
                      outlined
                      :items="packagingTypes"
                      label="Způsob balení"
                      v-model="form.preferredCustomPackaging"
                    >
                    </v-select>
                  </v-col>
                  <v-col></v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox :label="'Platba bankovním převodem'" v-model="form.paymentTransfer"></v-checkbox>
                    <v-checkbox :label="'Povolit dluh'" v-model="debtEnabled"></v-checkbox>
                  </v-col>
                </v-row>
                <v-row class="col-12">
                  <v-col cols="6">
                    <v-text-field
                      v-if="debtEnabled"
                      type="number"
                      v-model="form.maxDebt"
                      prepend-icon="mdi-cash-minus"
                      label="Maxmimální dluh"
                      min="0"
                      outlined
                      :rules="[rules.number]"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-if="debtEnabled"
                      type="number"
                      v-model="form.debtAlert"
                      prepend-icon="mdi-alert"
                      label="Oznámení při překročení dluhu"
                      min="0"
                      outlined
                      :rules="[rules.number]"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-btn
                  :disabled="!formValid || wait"
                  color="warning"
                  class="mr-4"
                  @click="save"
                >
                  Zapsat
                </v-btn>
              </v-container>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import rules from '../../../mixins/rules'

export default {
  name: 'UserForm',
  mixins: [rules],
  props: ['item', 'districts', 'foodTypes'],
  data () {
    return {
      wait: false,
      payByBank: false,
      credits: false,
      debt: false,
      maxDebt: 0,
      dialog: true,
      show1: false,
      show2: false,
      form: {
        ...this.item,
        debtAlert: String(this.item.debtAlert),
        password: '',
        passwordConfirmation: '',
        delivery: !!this.item.deliveryStreet,
        roleId: 6,
        company: !!this.item.companyName,
        maxDebt: String(this.item.maxDebt),
        preferredCustomPackaging: !!this.item.preferredCustomPackaging
      },
      packagingTypes: [
        {
          text: 'Standardní balení',
          value: false
        },
        {
          text: 'Vlastní nádoba',
          value: true
        }
      ],
      debtEnabled: !!this.item.maxDebt,
      formRules: {
        passwordConfirmation: v => v === this.form.password || 'Zadejte prosím stejné heslo.'
      },
      formValid: true,
      model: ['Vuetify'],
      search: null
    }
  },
  methods: {
    save () {
      this.wait = true
      if (!this.debtEnabled) {
        this.form.maxDebt = 0
      }
      this.form.foodTypes = this.form.foodTypes || []
      const options = {
        method: this.item.id ? 'put' : 'post',
        url: `/admin/users${this.item.id ? '/' + this.item.id : ''}`,
        data: this.keysToSnakeCase({
          ...this.form,
          debtAlert: +this.form.debtAlert
        })
      }
      this.$http(options)
        .then(() => {
          this.$emit('data-saved')
        })
        .catch(err => {
          this.wait = false
          if (err.response.status === 422) {
            alert('E-mail je již používán.')
          }
        })
    }
  },
  computed: {
    title () {
      return this.item.firstName ? 'Upravit uživatele' : 'Přidat uživatele'
    }
  },
  watch: {
    'form.delivery': function (val) {
      if (!val) {
        this.form.deliveryStreet = null
        this.form.deliveryStreetNumber = null
        this.form.deliveryCity = null
        this.form.deliveryZip = null
        this.form.deliveryCityDistrictId = null
      }
    },
    'form.company': function (val) {
      if (!val) {
        this.form.companyName = null
        this.form.dic = null
        this.form.ico = null
      }
    }
  }
}
</script>

<style scoped>
</style>
